import baseService from "services/base-service";
import {
  IAddEditCourseMaterialRequest,
  ICourseMaterialPagePayloadValues,
  ISCOListByCourseIdRequest,
} from "utils/interfaces/course";
import { PendingCourseEnrollmentEducatorsValues } from "./types";

const courseBaseUrl = `/api/Courses`;

const getCourseList = async (payload: {
  sortColumn: string;
  sortBy: number;
  pageNo: number;
  pageSize: number;
  name: string;
  courseNo?: string;
  stream?: string;
}) => baseService.post(`${courseBaseUrl}/GetCourses`, payload);

const addCourse = async (payload: {
  name: string;
  courseNo: string;
  stream: string;
  previousName: string;
  skills: string;
  knowledge: string;
  attitudes: string;
  courseAvailableInThisTerm: number;
  noOfSession: number;
  lengthOfSingleSession: number;
  description: string;
  isRecommendedForEducator: boolean;
  recommendedTo: number | null;
}) => baseService.post(courseBaseUrl, payload);

const editCourse = async (payload: {
  id: number;
  name: string;
  courseNo: string;
  stream: string;
  previousName: string;
  skills: string;
  knowledge: string;
  attitudes: string;
  courseAvailableInThisTerm: number;
  noOfSession: number;
  lengthOfSingleSession: number;
  description: string;
  isRecommendedForEducator: boolean;
  recommendedTo: number | null;
}) => baseService.put(courseBaseUrl, payload);

const deleteCourse = async (payload: { id: number }) =>
  baseService.delete(`${courseBaseUrl}?id=${payload.id}`);

const getCourseById = async (payload: { id: number }) =>
  baseService.get(`${courseBaseUrl}?id=${payload.id}`);

const getPendingCourseEnrollmentEducators = async (
  payload: PendingCourseEnrollmentEducatorsValues
) =>
  baseService.get(
    `${courseBaseUrl}/GetPendingCourseEnrollmentEducators?courseId=${payload.courseId}&isAll=${payload.isAll}`
  );

const getCourseMaterialList = async (
  payload: ICourseMaterialPagePayloadValues
) => baseService.post(`${courseBaseUrl}/GetAllCourseMaterials`, payload);

const addCourseMaterial = async (payload: IAddEditCourseMaterialRequest) => {
  const headers = {
    contentType: "multipart/form-data",
  };

  return baseService.post(`${courseBaseUrl}/AddCourseMaterial`, payload, {
    headers,
  });
};

const editCourseMaterial = async (payload: IAddEditCourseMaterialRequest) => {
  const headers = {
    contentType: "multipart/form-data",
  };

  return baseService.put(`${courseBaseUrl}/EditCourseMaterial`, payload, {
    headers,
  });
};

const getCourseMaterialById = async (payload: { id: number }) =>
  baseService.get(`${courseBaseUrl}/CourseMaterial?id=${payload.id}`);

const deleteCourseMaterial = async (payload: { id: number }) =>
  baseService.delete(`${courseBaseUrl}/CourseMaterial?id=${payload.id}`);

const getSCOListByCourseId = async (payload: ISCOListByCourseIdRequest) =>
  baseService.post(`${courseBaseUrl}/GetSCOListByCourseId`, payload);

export default {
  getCourseList,
  addCourse,
  editCourse,
  deleteCourse,
  getCourseById,
  getPendingCourseEnrollmentEducators,
  getCourseMaterialList,
  addCourseMaterial,
  editCourseMaterial,
  getCourseMaterialById,
  deleteCourseMaterial,
  getSCOListByCourseId,
};
